<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_viii"></a><strong>Approximations of the Pronunciation of Names and Words</strong></h2>
<table width="100%">
<tbody><tr>
<td><img alt="images" src="images/01.jpg"/></td>
<td>AK-<span class="small">SEL</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/02.jpg"/></td>
<td>BEST-<span class="small">EH-MOOR</span></td>
<td><span class="small">GRANDMOTHER</span></td>
</tr>
<tr>
<td><img alt="images" src="images/03.jpg"/></td>
<td>DROWG</td>
<td><span class="small">WATER CREATURE</span></td>
</tr>
<tr>
<td><img alt="images" src="images/04.jpg"/></td>
<td>ES-<span class="small">PEN</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/05.jpg"/></td>
<td>FAR</td>
<td><span class="small">FATHER</span></td>
</tr>
<tr>
<td><img alt="images" src="images/06.jpg"/></td>
<td>FYORD</td>
<td><span class="small">AN INLET OF THE SEA BETWEEN HIGH CLIFFS</span></td>
</tr>
<tr>
<td><img alt="images" src="images/07.jpg"/></td>
<td>GOOST</td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/08.jpg"/></td>
<td>HAWK-<span class="small">ON</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/09.jpg"/></td>
<td>HI</td>
<td><span class="small">HELLO</span></td>
</tr>
<tr>
<td><img alt="images" src="images/10.jpg"/></td>
<td>HEERD</td>
<td><span class="small">NORWEGIAN NAZI STORM TROOPERS</span></td>
</tr>
<tr>
<td><img alt="images" src="images/11.jpg"/></td>
<td>HYAL-<span class="small">MER</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/12.jpg"/></td>
<td><span class="small">HUL</span>-DRA</td>
<td><span class="small">TROLL HAG</span></td>
</tr>
<tr>
<td><img alt="images" src="images/13.jpg"/></td>
<td>VEP-<span class="small">SEN</span></td>
<td><span class="small">THE <em>WASP</em></span></td>
</tr>
<tr>
<td><img alt="images" src="images/14.jpg"/></td>
<td>ING-<span class="small">GRID</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/15.jpg"/></td>
<td>YA</td>
<td><span class="small">YES</span></td>
</tr>
<tr>
<td><img alt="images" src="images/16.jpg"/></td>
<td>YENS</td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/17.jpg"/></td>
<td><span class="small">YO-TUN</span>-HEIM-<span class="small">EN</span></td>
<td><span class="small">LAND OF THE GIANTS</span></td>
</tr>
<tr>
<td><img alt="images" src="images/18.jpg"/></td>
<td>SHELL</td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/19.jpg"/></td>
<td>CRONE/CRO-<span class="small">NER</span></td>
<td><span class="small">CROWN/CROWNS: NORWEGIAN MONEY</span></td>
</tr>
<tr>
<td><img alt="images" src="images/20.jpg"/></td>
<td>LIFE</td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/21.jpg"/></td>
<td>LIL-<span class="small">LE-BEE</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/22.jpg"/></td>
<td>MOOR</td>
<td><span class="small">MOTHER</span></td>
</tr>
<tr>
<td><img alt="images" src="images/23.jpg"/></td>
<td>NIE</td>
<td><span class="small">NO</span></td>
</tr>
<tr>
<td><img alt="images" src="images/24.jpg"/></td>
<td>NISS-<span class="small">EH-LU-EH</span></td>
<td><span class="small">RED STOCKING HAT</span></td>
</tr>
<tr>
<td><img alt="images" src="images/25.jpg"/></td>
<td>OH-<span class="small">LEH</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/26.jpg"/></td>
<td>PEAR</td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/27.jpg"/></td>
<td>RAHG-<span class="small">NA</span>-ROK</td>
<td><span class="small">FINAL DESTRUCTION IN NORSE MYTHOLOGY</span></td>
</tr>
<tr>
<td><img alt="images" src="images/28.jpg"/></td>
<td>SOL-<span class="small">VAY</span></td>
<td> </td>
</tr>
<tr>
<td><img alt="images" src="images/29.jpg"/></td>
<td>TAHN-<span class="small">TEH MA</span>-REE</td>
<td><span class="small">AUNT MARIE</span></td>
</tr>
<tr>
<td><img alt="images" src="images/30.jpg"/></td>
<td>TOOS-<span class="small">EN</span> TUCK</td>
<td><span class="small">A THOUSAND THANKS</span></td>
</tr>
<tr>
<td><img alt="images" src="images/31.jpg"/></td>
<td>VAIR <span class="small">SO GO</span></td>
<td><span class="small">BE SO GOOD; HELP YOURSELF</span></td>
</tr>
</tbody></table>
<p class="noindent"><a id="page_ix"></a><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?33f4856b